var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDatasetsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9102"
    },
    d: "M460.676,93.752H61.28c-11.217,0-20.321,9.104-20.321,20.321v366.45 c0,11.217,9.104,20.321,20.321,20.321h399.397c11.217,0,20.321-9.104,20.321-20.321v-366.45 C480.997,102.856,471.893,93.752,460.676,93.752z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 97.3478,
    y1: 487.6078,
    x2: 475.9678,
    y2: 108.9878,
    gradientTransform: "matrix(1.0667 0 0 -1.0667 3.2667 557.533)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E8EFEE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M434.382,373.501H87.574c-11.222,0-20.321-9.098-20.321-20.321V29.404 c0-11.222,9.098-20.321,20.321-20.321h346.807c11.222,0,20.321,9.098,20.321,20.321v323.777 C454.703,364.403,445.604,373.501,434.382,373.501z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 252.7677,
    y1: 332.1877,
    x2: 11.8498,
    y2: 573.1078,
    gradientTransform: "matrix(1.0667 0 0 -1.0667 3.2667 557.533)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E8EFEE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_2_)"
    },
    d: "M73.688,359.615V35.839c0-11.222,9.098-20.321,20.321-20.321h346.807 c3.963,0,7.647,1.152,10.773,3.113c-3.594-5.728-9.947-9.548-17.207-9.548H87.574c-11.222,0-20.321,9.098-20.321,20.321v323.777 c0,7.261,3.82,13.614,9.548,17.207C74.84,367.263,73.688,363.577,73.688,359.615z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 130.25,
    y: 77.493,
    style: {
      fill: "#C2CECE"
    },
    width: 261.461,
    height: 14.901
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.25,
    y: 134.389,
    style: {
      fill: "#C2CECE"
    },
    width: 261.461,
    height: 14.901
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.25,
    y: 191.296,
    style: {
      fill: "#C2CECE"
    },
    width: 261.461,
    height: 14.901
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.25,
    y: 248.192,
    style: {
      fill: "#C2CECE"
    },
    width: 261.461,
    height: 14.901
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 188.9465,
    y1: 263.6066,
    x2: 114.4965,
    y2: 338.0565,
    gradientTransform: "matrix(1.0667 0 0 -1.0667 3.2667 557.533)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C2CECE",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    style: {
      stopColor: "#AFBCBC",
      stopOpacity: 0.179
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5B6A6A"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_3_)"
    },
    points: "161.407,200.098 227.11,265.801 161.407,265.801 "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 537.5638,
    y1: 237.2638,
    x2: 370.4538,
    y2: 404.3738,
    gradientTransform: "matrix(1.0667 0 0 -1.0667 3.2667 557.533)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC200",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    style: {
      stopColor: "#FDBB00",
      stopOpacity: 0.161
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.397,
    style: {
      stopColor: "#F7A700",
      stopOpacity: 0.397
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678,
    style: {
      stopColor: "#EE8700",
      stopOpacity: 0.678
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992,
    style: {
      stopColor: "#E05B00",
      stopOpacity: 0.992
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E05A00"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_4_)"
    },
    points: "480.997,271.22 480.997,120.048 454.703,93.752 454.703,271.22 "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 236.9373,
    y1: 81.9073,
    x2: 236.9373,
    y2: 54.9373,
    gradientTransform: "matrix(1.0667 0 0 -1.0667 3.2667 557.533)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC200"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.268,
    style: {
      stopColor: "#FFBB00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.659,
    style: {
      stopColor: "#FFA801"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF9102"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_5_)"
    },
    d: "M511.796,284.895l-28.33,200.544c-1.417,10.026-9.997,17.478-20.121,17.478H58.61 c-10.125,0-18.704-7.453-20.121-17.478L0.204,214.455c-1.728-12.233,7.767-23.164,20.121-23.164h124.99 c10.124,0,18.704,7.452,20.121,17.476l5.017,35.487c1.417,10.025,9.997,17.476,20.121,17.476h301.103 C504.029,261.731,513.524,272.662,511.796,284.895z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 241.6048,
    y1: 111.4073,
    x2: 241.6048,
    y2: 142.8973,
    gradientTransform: "matrix(1.0667 0 0 -1.0667 3.2667 557.533)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9102"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    style: {
      stopColor: "#FF9409"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.314,
    style: {
      stopColor: "#FF9C1D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.537,
    style: {
      stopColor: "#FFAA3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    style: {
      stopColor: "#FFBC69"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCF95"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_6_)"
    },
    d: "M411.42,413.465H110.537c-3.412,0-6.292-2.539-6.72-5.924l-3.764-29.804 c-0.511-4.046,2.642-7.622,6.72-7.622h308.411c4.078,0,7.231,3.577,6.72,7.622l-3.764,29.804 C417.712,410.926,414.832,413.465,411.42,413.465z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatasetsIcon);
export default __webpack_public_path__ + "static/media/datasets-icon.e07c77a1cf591d9eefeef509887fd528.svg";
export { ForwardRef as ReactComponent };